import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imCustomFieldCheckboxFilter', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/filters/custom-fields-filters/checkbox/checkbox.html'),
        controller: 'CheckboxCustomFieldFilterController',
        controllerAs: 'CheckboxCustomFieldFilterCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            field: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/custom-fields-filters/checkbox/checkbox.component.ts